import React from 'react'
import Footer from '../../components/Footer/Footer'
import Header from '../../components/Header/Header'
import { Outlet } from 'react-router-dom'
import ScrollToTopButton from '../../components/scroll-to-top/ScrollToTop'

const WebsiteLayout = () => {
    return (
        <div className="flex w-full items-center justify-center">
            <div className='flex flex-col gap-[80px] lg:mx-[120px] px-[15px] lg:px-0 w-full xl:max-w-[1400px]  bg-offwhite'>

                <Header />

                <Outlet />
                
                <ScrollToTopButton />

                <Footer />

            </div>
        </div>
    )
}

export default WebsiteLayout